var map = {
	"./payment-01.png": 1752,
	"./payment-02.png": 2595,
	"./payment-03.png": 5482,
	"./payment-04.png": 149,
	"./payment-05.png": 2636,
	"./payment-06.png": 1367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1210;